export default {
    meta: {
        title: '隐私政策',
        isShowHeader: false,
    },
};
